let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a1bQd")).then(() => parcelRequire('34low'));